/* eslint-disable max-len */
import React from "react";
// import PropTypes from 'prop-types';
import classNames from "classnames";

export default function IconMenu({ className }) {
  const iconClasses = classNames("icon menu", className);

  return (
    <svg
      className={iconClasses}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
    >
      <path d="M 3 7 A 1.0001 1.0001 0 1 0 3 9 L 27 9 A 1.0001 1.0001 0 1 0 27 7 L 3 7 z M 3 14 A 1.0001 1.0001 0 1 0 3 16 L 27 16 A 1.0001 1.0001 0 1 0 27 14 L 3 14 z M 3 21 A 1.0001 1.0001 0 1 0 3 23 L 27 23 A 1.0001 1.0001 0 1 0 27 21 L 3 21 z" />
    </svg>
  );
}
